import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "@/lib/api";
import { PenLine, ArrowLeft } from "lucide-react";

// Public read-only share view. Uses raw fetch (no auth needed).
export default function PublicScriptPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    fetch(`${API}/public/scripts/${token}`)
      .then((r) => r.ok ? r.json() : Promise.reject(r))
      .then(setData)
      .catch(() => setErr("Link not found or has been revoked."));
  }, [token]);

  if (err) return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="max-w-md text-center">
        <div className="mono-label mb-3">404</div>
        <h1 className="font-serif-display text-4xl mb-3">Link unavailable</h1>
        <p style={{ color: "var(--ink-2)" }}>{err}</p>
      </div>
    </div>
  );

  if (!data) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="mono-label pulse-soft">Loading script</div>
    </div>
  );

  return (
    <div className="min-h-screen">
      <header className="hair-b px-6 lg:px-10 py-4 flex items-center justify-between" style={{ background: "var(--paper)" }}>
        <div className="flex items-center gap-3">
          <PenLine className="w-5 h-5" style={{ color: "var(--primary)" }} />
          <span className="font-serif-display text-2xl tracking-tight">Scriptora</span>
          <span className="mono-label ml-4 hidden sm:inline">Shared script</span>
        </div>
        <a href="/" className="btn-ghost text-sm px-3 py-2 rounded-md inline-flex items-center gap-2" data-testid="public-back-home">
          <ArrowLeft className="w-4 h-4" /> Open Scriptora
        </a>
      </header>

      <main className="max-w-3xl mx-auto p-6 lg:p-12">
        <div className="mono-label mb-2">{data.script_type} · shared by {data.client_name || "a writer"}</div>
        <h1 className="font-serif-display text-4xl md:text-5xl tracking-tight leading-tight" data-testid="public-script-topic">
          {data.topic}
        </h1>
        <div className="mt-8 tint-lavender-soft hair rounded-md p-8">
          <div className="script-body" data-testid="public-script-content">{data.content}</div>
        </div>
        <div className="mono-label mt-6">{new Date(data.created_at).toLocaleString()}</div>
      </main>
    </div>
  );
}
